import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Cidade } from './modelos/cidade';
import { Orgao } from './modelos/orgao';
import { TipoSolicitacao } from './modelos/tipoSolicitacao';
import { environment } from '../environments/environment';
import { TipoSolicitante } from './modelos/tipoSolicitante';
import { EstadoCivil } from './modelos/estadoCivil';
@Injectable({
  providedIn: 'root'
})
export class ConsumirApiService {

  private baseURL = environment.API;

  constructor(private http: HttpClient) { }

  cadastrar(formData: FormData): any {

    return this.http.post(this.baseURL + '/solicitacao', formData)
    .pipe(map(res => res));
  }

  verificarEmailSolicitante(email): any {

    const body = {
      email: email
    };

    return this.http.post(this.baseURL + '/verificarEmail', body)
    .pipe(map(res => res));
  }

  validarEmailSolicitante(email, codigo): any {

    const body = {
      email: email,
      codigo_autenticidade: codigo
    };

    return this.http.post(this.baseURL + '/validarEmail', body)
    .pipe(map(res => res));
  }

  validarAutenticidade(codigo_autenticidade): any {

    return this.http.get(this.baseURL + `/verificarAutenticidade?id=${codigo_autenticidade}`)
    .pipe(map(res => res));
  }

  buscaCidades(): any {
    return this.http.get<Cidade[]>(this.baseURL + '/cidades');
  }

  buscaTipoSolicitacao(): any {
    return this.http.get<TipoSolicitacao[]>(this.baseURL + '/tipo-solicitacao')
  }

  buscaOrgaos(): any {
    return this.http.get<Orgao[]>(this.baseURL + '/orgaos');
  }

  buscaEstadoCivil(): any {
    return this.http.get<EstadoCivil[]>(this.baseURL + '/estadoCivil');
  }

  buscaTipoSolicitante(): any {
    return this.http.get<TipoSolicitante[]>(this.baseURL + '/tipoSolicitante');
  }

}
